document.addEventListener('DOMContentLoaded', function() {
    const popupOverlay = document.getElementById('bfcm-popup-overlay');
    const form = document.getElementById('bfcm-signup-form');
    const msgContainer = document.getElementById('bfcm-form-message');
    
    if (!popupOverlay) return;

    if (popupOverlay.classList.contains('enabled-by-settings')) {
        popupOverlay.style.display = 'flex';
        setTimeout(() => popupOverlay.classList.add('is-visible'), 10);
    }
    function setCookie(name, value, days) {
        const expires = new Date();
        expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
        document.cookie = name + '=' + value + ';expires=' + expires.toUTCString() + ';path=/';
    }

    function getCookie(name) {
        const nameEQ = name + '=';
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    const timerDaysElement = document.getElementById('bfcm-timer-days');
    const timerDays = timerDaysElement ? parseInt(timerDaysElement.dataset.days) : 7;
    let savedEndTime = getCookie('bfcm_timer_end');
    let countDownDate;

    if (savedEndTime) {
        countDownDate = parseInt(savedEndTime);
        if (new Date().getTime() > countDownDate) {
            countDownDate = new Date().getTime() + (24 * 60 * 60 * 1000);
            setCookie('bfcm_timer_end', countDownDate, 365);
        }
    } else {
        countDownDate = new Date().getTime() + (timerDays * 24 * 60 * 60 * 1000);
        setCookie('bfcm_timer_end', countDownDate, 365);
    }
    
    const timerInterval = setInterval(function() {
        const now = new Date().getTime();
        const distance = countDownDate - now;

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        const timerElement = document.getElementById("bfcm-timer-display");
        if(timerElement) {
            timerElement.innerHTML = 
            `<span class="timer-part">${days.toString().padStart(2, '0')} <span class="timer--unit unit">DAYS</span></span> : ` +
            `<span class="timer-part">${hours.toString().padStart(2, '0')} <span class="timer--unit unit">HRS</span></span> : ` +
            `<span class="timer-part">${minutes.toString().padStart(2, '0')} <span class="timer--unit unit">MIN</span></span> : ` +
            `<span class="timer-part">${seconds.toString().padStart(2, '0')} <span class="timer--unit unit">SEC</span></span>`;
        }

        if (distance < 0) {
            clearInterval(timerInterval);
            countDownDate = new Date().getTime() + (24 * 60 * 60 * 1000);
            setCookie('bfcm_timer_end', countDownDate, 365);
            location.reload();
        }
    }, 1000);

    if(form) {
        form.addEventListener('submit', function(e) {
            e.preventDefault();
            
            const email = document.getElementById('bfcm-email').value;
            const name = document.getElementById('bfcm-name').value;
            const submitBtn = document.getElementById('bfcm-submit-btn');
            
            const listId = form.dataset.listId; 
            const companyId = form.dataset.companyId;
            
            submitBtn.innerText = 'Processing...';
            submitBtn.disabled = true;
            msgContainer.innerHTML = '';

            const options = {
                method: 'POST',
                headers: {
                    'revision': '2024-02-15',
                    'content-type': 'application/json'
                },
                body: JSON.stringify({
                    data: {
                        type: 'subscription',
                        attributes: {
                            custom_source: 'BFCM 2025 Popup (Permanent)', 
                            profile: {
                                data: {
                                    type: 'profile',
                                    attributes: {
                                        email: email,
                                        first_name: name
                                    }
                                }
                            }
                        },
                        relationships: {
                            list: {
                                data: {
                                    type: 'list',
                                    id: listId
                                }
                            }
                        }
                    }
                })
            };

            fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${companyId}`, options)
            .then(response => {
                if (response.ok || response.status === 202) {
                    msgContainer.className = 'bfcm-message bfcm-success';
                    msgContainer.innerText = 'SUCCESS! YOU ARE ON THE LIST.';
                    submitBtn.innerText = 'JOINED';
                    form.reset();
                } else {
                    return response.json().then(errorData => {
                        throw new Error(errorData.errors?.[0]?.detail || 'Subscription failed');
                    });
                }
            })
            .catch(err => {
                console.error('Klaviyo Error:', err);
                msgContainer.className = 'bfcm-message bfcm-error';
                msgContainer.innerText = err.message || 'Error joining list. Please try again.';
                submitBtn.innerText = 'TRY AGAIN';
                submitBtn.disabled = false;
            });
        });
    }
});